import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sort-switch" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_switch, {
      modelValue: _ctx.updateSort,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.updateSort) = $event)),
      "inline-prompt": "",
      "active-text": "降順",
      "inactive-text": "昇順",
      width: 60,
      size: "small",
      "inactive-color": "#E6A23C"
    }, null, 8, ["modelValue"])
  ]))
}